/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Name_Is_Reserved_Or_InvInputs */

const en_this_name_is_reserved_or_inv = /** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This name is reserved or invalid`)
};

const id_this_name_is_reserved_or_inv = /** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama ini dicadangkan atau tidak valid`)
};

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const es_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const fr_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const de_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const ja_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const zh_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const ar_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const it_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const ru_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const pt_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/** @type {(inputs: This_Name_Is_Reserved_Or_InvInputs) => LocalizedString} */
const ko_this_name_is_reserved_or_inv = en_this_name_is_reserved_or_inv;

/**
* | output |
* | --- |
* | "This name is reserved or invalid" |
*
* @param {This_Name_Is_Reserved_Or_InvInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const this_name_is_reserved_or_inv = /** @type {((inputs?: This_Name_Is_Reserved_Or_InvInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Name_Is_Reserved_Or_InvInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_this_name_is_reserved_or_inv(inputs)
	if (locale === "es") return es_this_name_is_reserved_or_inv(inputs)
	if (locale === "fr") return fr_this_name_is_reserved_or_inv(inputs)
	if (locale === "de") return de_this_name_is_reserved_or_inv(inputs)
	if (locale === "ja") return ja_this_name_is_reserved_or_inv(inputs)
	if (locale === "zh") return zh_this_name_is_reserved_or_inv(inputs)
	if (locale === "ar") return ar_this_name_is_reserved_or_inv(inputs)
	if (locale === "id") return id_this_name_is_reserved_or_inv(inputs)
	if (locale === "it") return it_this_name_is_reserved_or_inv(inputs)
	if (locale === "ru") return ru_this_name_is_reserved_or_inv(inputs)
	if (locale === "pt") return pt_this_name_is_reserved_or_inv(inputs)
	return ko_this_name_is_reserved_or_inv(inputs)
});